/// <summary>
/// This object provides js functions for the Bluaul.VC.Widget.Events.EmaxProtocolList.cs <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 29.11.2022<br />
/// Copyright ©: EUDT GmbH 2022 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 29.11.2022                                              *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
jQuery.widget("bluaul.EmaxProtocolList", jQuery.common.VisualBase, {
   Init: true,

    _create: function () {
        var me = this;
        try {
            me.element.html("");
            // set the Visual-Name first
            me.options.invoke.vcvid = 348;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));
            me._super();
         
        } catch (e) { me._writeErr(e); return false;}
        return true;
    },

    _initHTML: function () {
        var me = this;
        try {
         
            me.showMessage("", false);
            ////adopt heights and widths
            var h = parseInt(me.visual.height() -  me.fnd(".vc-list-header").height() -60);
            me.fnd(".lst-entries").height(parseInt(h));

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {

            me._setStyle();
           
            //init the full-text search
            me.fnd("#div-filter").vcFilter({callback: function () { me._filter();}});

           me.fnd("#div-date").vcDate({
                mode: "Range", align: "center", interval: 1, langID: me.settings.userLangID, callback: function () {
                   if (!me.Init) me._fetch();
                   me.Init = false;
                }
            })

        } catch (e) { me._writeErr(e);return false; }
        return true;
    },


    _setStyle: function () {
        var me = this;
        me.fnd(".vc-list .col0").width(180);
        me.fnd(".vc-list .col1").width(80);
        me.fnd(".vc-list .col2").width(400);
        me.fnd(".vc-list").css("font-size", "smaller");
        me.fnd(".vc-list .vc-list-item").css("padding", "5px 6px");
    },


    _filter: function () {
        /// <summary>
        /// This function filters list entries
        /// </summary>
        var me = this;
        try {

            //hide all
            me.fnd(".lst-entries .vc-list-item").removeClass("found").data("counter", 0).hide();

            //we add the 'found' class to all items we want to filter based on the vcfilter tags
            me.setTagFilter(".vc-filter", ".lst-entries .vc-list-item", "found");

            me.fnd(".lst-entries .vc-list-item.found").show();
            me.fnd(".lst-entries .vc-list-item").removeClass("alt");
            me.fnd(".lst-entries .vc-list-item.found:even").addClass("alt");


        } catch (e) { me._writeErr(e);return false; }
        return true;
    },


    _fetch: function () {
        /// <summary>
        /// This function fetches existing entries incl. filter options
        /// </summary>
        var me = this;
        var param;
        try {
            var dt = me.fnd("#div-date").vcDate("getDateRange");

            param = {};
            param.Aid = me.options.parameter.Aid;
            param.StartDate = dt.from;
            param.EndDate = dt.to;


            me.fnd(".lst-entries").html(me.getLoadingIcon());
            $("#divDebug").append("<br/>url4");
            me.getData(param, function (result) {
                //check response content
               if (result == null) {
                   me.showMessage(me.resources.err_loadData, true);
                   return true;
               }
               
                me._generateList(result);

                me._filter();
                return true;
            });

        } catch (e) { me._writeErr(e); return false;}
        return true;
    },


    _generateList: function (dtt) {
        /// <summary>
        /// This function generates a list from the data and ...
        /// nothing too complicated
        /// </summary>
        var me = this;
        var item, col, col1, col2;
        var list;
        try {

            list = me.fnd(".lst-entries");
            list.html("");

            if (dtt === null) {
                list.html($("<br>"));
                list.append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }
             
            if (dtt.rows === null) {
                list.html($("<br>"));
                list.append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }
           

            for (var i = 0; i < dtt.rows.length; i++) {

                item = $("<div>", { "class": "vc-list-item" });


                col1 = $("<div>", { "class": "vc-list-col col0" });
                col1.append($("<div>", { "class": "vc-list-col-element", "html": moment(dtt.rows[i].timestamp, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY HH:mm:ss') }));
                item.append(col1);


                var v = $("<span>").css("font-weight", "bold");
                v.html(me.specific.resources.on);
                if (dtt.rows[i].val == false) v.html(me.specific.resources.off);


                col2 = $("<div>", { "class": "vc-list-col  col1" });
                col2.append($("<div>", { "class": "vc-list-col-element", "html": v }));
                item.append(col2);


                col = $("<div>", { "class": "vc-list-col col2" });
                col.width(500);
                col.append($("<div>", { "class": "vc-list-col-element", "html": dtt.rows[i].name }));
                item.append(col);
            
                list.append(item);
            }

            me.fnd('.lst-entries .vc-list-item:even').addClass('alt');

            me._setStyle();

            return true;
        } catch (e) {
            me._writeErr(e);return false;
        }

    },

    
    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.fnd(".lst-entries, #div-filter-menu").hide();
            }
            return true;
        } catch (e) { me._writeErr(e); return false;}
    }


});

